import { ComponentNameEnum, BaseFieldConfig } from '@/types';

const socialNetworkInputGroupConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.SOCIAL_NETWORK_INPUT_GROUP,
  options: {
    defaultValue: [],
    draggable: true,
  },
};

export default socialNetworkInputGroupConfig;
